// // import React from 'react';
// // import { Outlet } from 'react-router-dom';
// // import AdminHeader from '../Layout/AdminHeader';

// // const AdminLayout = () => {
// //   return (
// //     <div className="admin-layout">
// //       <AdminHeader />
      
// //       {/* Main content area - Same pattern as BusinessLayout */}
// //       <main className="admin-main">
// //         <Outlet />
// //       </main>
      
     
      
// //     </div>
// //   );
// // };

// // export default AdminLayout;

// //web view 





// import React from 'react';
// import { Outlet } from 'react-router-dom';
// import AdminHeader from './AdminHeader';

// const AdminLayout = () => {
//   return (
//     <div className="admin-layout flex flex-col min-h-screen">
//       <AdminHeader />
//       {/* admin-main class ensures proper spacing from the fixed header on mobile */}
//       <main className="admin-main flex-grow">
//         <Outlet />
//       </main>
//     </div>
//   );
// };

// export default AdminLayout;





import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminHeader from './AdminHeader';

const AdminLayout = () => {
  return (
    <div className="admin-layout flex flex-col min-h-screen">
      <AdminHeader />
      
      {/* admin-main ensures proper spacing from fixed header */}
      <main className="admin-main flex-grow">
        <Outlet />
      </main>

      <style dangerouslySetInnerHTML={{ __html: `
        .admin-layout {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }
        .admin-main {
          padding-top: 70px; /* Base padding for mobile */
          background: #FAF9F6;
          min-height: calc(100vh - 70px);
          flex: 1;
        }
        @media (min-width: 992px) {
          .admin-main {
            padding-top: 80px; /* Original padding for web view */
            min-height: calc(100vh - 80px);
          }
        }
      ` }} />
    </div>
  );
};

export default AdminLayout;